import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

function initLightbox() {
  if (document.getElementById('tsr-lightbox-overlay')) return;

  const overlay = document.createElement('div');
  overlay.id = 'tsr-lightbox-overlay';
  overlay.innerHTML = `
    <div class="tsr-lb-header">
      <span class="tsr-lb-counter"></span>
      <div class="tsr-lb-actions">
        <button class="tsr-lb-btn-fullscreen" title="Fullscreen">
          <svg viewBox="0 0 24 24" width="18" height="18"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" fill="currentColor"/></svg>
        </button>
        <button class="tsr-lb-btn-zoom" title="Zoom">
          <svg viewBox="0 0 24 24" width="18" height="18"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="currentColor"/><path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z" fill="currentColor"/></svg>
        </button>
        <button class="tsr-lb-btn-share" title="Share">
          <svg viewBox="0 0 24 24" width="18" height="18"><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" fill="currentColor"/></svg>
        </button>
        <button class="tsr-lb-close" title="Close (Esc)">
          <svg viewBox="0 0 24 24" width="18" height="18"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
        </button>
      </div>
    </div>
    <div class="tsr-lb-content">
      <button class="tsr-lb-prev" title="Previous">
        <svg viewBox="0 0 24 24" width="24" height="24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="currentColor"/></svg>
      </button>
      <div class="tsr-lb-img-wrap">
        <img class="tsr-lb-img" src="" alt="">
      </div>
      <button class="tsr-lb-next" title="Next">
        <svg viewBox="0 0 24 24" width="24" height="24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill="currentColor"/></svg>
      </button>
    </div>
    <div class="tsr-lb-footer">
      <span class="tsr-lb-title"></span>
    </div>
  `;
  document.body.appendChild(overlay);

  const style = document.createElement('style');
  style.textContent = `
    #tsr-lightbox-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.9);z-index:100000;display:none;flex-direction:column}
    #tsr-lightbox-overlay.active{display:flex}
    .tsr-lb-header{display:flex;justify-content:space-between;align-items:center;padding:12px 20px;z-index:100002;flex-shrink:0}
    .tsr-lb-counter{color:rgba(255,255,255,.9);font-size:14px;font-weight:400}
    .tsr-lb-actions{display:flex;gap:8px}
    .tsr-lb-actions button{background:none;border:none;color:rgba(255,255,255,.8);cursor:pointer;padding:6px;border-radius:50%;transition:background .2s}
    .tsr-lb-actions button:hover{background:rgba(255,255,255,.15)}
    .tsr-lb-close svg{display:block}
    .tsr-lb-content{flex:1;display:flex;align-items:center;justify-content:center;min-height:0;position:relative}
    .tsr-lb-img-wrap{flex:1;display:flex;align-items:center;justify-content:center;min-height:0;padding:0 70px}
    .tsr-lb-img{max-width:100%;max-height:calc(100vh - 120px);object-fit:contain;display:block}
    .tsr-lb-prev,.tsr-lb-next{position:absolute;top:50%;transform:translateY(-50%);background:rgba(255,255,255,.1);border:none;color:#fff;padding:16px 12px;cursor:pointer;border-radius:4px;z-index:100003;transition:background .2s}
    .tsr-lb-prev{left:12px}.tsr-lb-next{right:12px}
    .tsr-lb-prev:hover,.tsr-lb-next:hover{background:rgba(255,255,255,.25)}
    .tsr-lb-prev svg,.tsr-lb-next svg{display:block}
    .tsr-lb-footer{text-align:center;padding:10px 20px;flex-shrink:0;z-index:100002}
    .tsr-lb-title{color:rgba(255,255,255,.85);font-size:13px}
    .tsr-lb-img.tsr-lb-zoomed{max-width:none;max-height:none;cursor:zoom-out}
    .tsr-lb-actions button svg{display:block}
  `;
  document.head.appendChild(style);

  let items = [];
  let currentIdx = 0;
  const img = overlay.querySelector('.tsr-lb-img');
  const counter = overlay.querySelector('.tsr-lb-counter');
  const title = overlay.querySelector('.tsr-lb-title');

  function show(idx) {
    if (idx < 0 || idx >= items.length) return;
    currentIdx = idx;
    img.classList.remove('tsr-lb-zoomed');
    img.src = items[idx].href;
    counter.textContent = (idx + 1) + ' / ' + items.length;
    title.textContent = items[idx].title || '';
  }

  overlay.querySelector('.tsr-lb-close').addEventListener('click', () => { if(document.fullscreenElement) document.exitFullscreen(); overlay.classList.remove('active'); });
  overlay.querySelector('.tsr-lb-btn-fullscreen').addEventListener('click', (e) => { e.stopPropagation(); if(document.fullscreenElement) document.exitFullscreen(); else overlay.requestFullscreen().catch(()=>{}); });
  overlay.querySelector('.tsr-lb-btn-zoom').addEventListener('click', (e) => { e.stopPropagation(); img.classList.toggle('tsr-lb-zoomed'); });
  overlay.querySelector('.tsr-lb-btn-share').addEventListener('click', (e) => { e.stopPropagation(); if(navigator.share) navigator.share({url:img.src}).catch(()=>{}); else { navigator.clipboard.writeText(window.location.href).catch(()=>{}); } });
  overlay.addEventListener('click', (e) => { if (e.target === overlay || e.target.classList.contains('tsr-lb-content')) { if(document.fullscreenElement) document.exitFullscreen(); overlay.classList.remove('active'); } });
  overlay.querySelector('.tsr-lb-prev').addEventListener('click', (e) => { e.stopPropagation(); show(currentIdx - 1); });
  overlay.querySelector('.tsr-lb-next').addEventListener('click', (e) => { e.stopPropagation(); show(currentIdx + 1); });

  document.addEventListener('keydown', (e) => {
    if (!overlay.classList.contains('active')) return;
    if (e.key === 'Escape') { if(document.fullscreenElement) document.exitFullscreen(); overlay.classList.remove('active'); }
    if (e.key === 'ArrowLeft') show(currentIdx - 1);
    if (e.key === 'ArrowRight') show(currentIdx + 1);
  });

  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[data-elementor-open-lightbox="yes"]');
    if (!link) return;
    e.preventDefault();

    const slideshow = link.getAttribute('data-elementor-lightbox-slideshow');
    const selector = slideshow
      ? `a[data-elementor-lightbox-slideshow="${slideshow}"]`
      : 'a[data-elementor-open-lightbox="yes"]';
    items = Array.from(document.querySelectorAll(selector)).map(a => ({
      href: a.getAttribute('href'),
      title: a.getAttribute('data-elementor-lightbox-title') || ''
    }));
    currentIdx = items.findIndex(it => it.href === link.getAttribute('href'));
    if (currentIdx < 0) currentIdx = 0;
    show(currentIdx);
    overlay.classList.add('active');
  });
}

function ElementorInit() {
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!window.jQuery) return;
      const $ = window.jQuery;

      // React Header owns the mega menu; skip WPR widget init (needs .wpr-mobile-nav-menu in-widget)
      try {
        const headerMenuWidget = document.querySelector('.elementor-element-a262c40')
        if (headerMenuWidget) {
          headerMenuWidget.removeAttribute('data-widget_type')
        }
      } catch (e) {}

      // Re-run Elementor frontend after React route change (animations, background video, WPR widgets)
      try {
        const ef = window.elementorFrontend;
        if (ef && typeof ef.init === 'function') {
          ef.init();
        } else if (ef?.elementsHandler?.attachHandler) {
          document.querySelectorAll('.elementor-element').forEach((el) => {
            if (el.classList.contains('elementor-element-a262c40')) return;
            ef.elementsHandler.runReadyTrigger(el);
          });
        }
      } catch (e) {
        console.log('Elementor frontend init error:', e);
      }

      // React Header owns mobile menu toggling; prevent WPR jQuery handlers from fighting it
      try {
        const $headerMenu = $('.elementor-element-a262c40');
        $headerMenu.find('.wpr-mobile-toggle').off();
        $headerMenu.find('.wpr-mobile-nav-menu-container a').off();
      } catch (e) {}

      // Re-init WPR mega menu hover behavior (toggle wpr-animate-sub class for CSS transitions)
      try {
        $('.wpr-nav-menu .menu-item-has-children, .wpr-mega-menu .menu-item-has-children')
          .off('mouseenter.wpr mouseleave.wpr')
          .on('mouseenter.wpr', function() {
            $(this).children('.wpr-sub-menu, .sub-menu').addClass('wpr-animate-sub');
          })
          .on('mouseleave.wpr', function() {
            $(this).children('.wpr-sub-menu, .sub-menu').removeClass('wpr-animate-sub');
          });
      } catch(e) {}

      // Init WPR testimonial Slick carousels (re-init so settings beat elementorFrontend.init)
      try {
        $('.wpr-testimonial-carousel').each(function() {
          const $el = $(this);
          const widget = $el.closest('.elementor-widget');
          const widgetSettings = widget.data('settings') || {};
          let slickData = $el.data('slick') || {};
          const dataSlickAttr = $el.attr('data-slick');
          if (dataSlickAttr) {
            try {
              slickData = { ...slickData, ...JSON.parse(dataSlickAttr) };
            } catch (e) {}
          }

          const slidesToShow = parseInt(widgetSettings.testimonial_amount, 10) || 1;
          const slidesToShowTablet = parseInt(widgetSettings.testimonial_amount_tablet, 10) || 2;
          const slidesToShowMobile = parseInt(widgetSettings.testimonial_amount_mobile, 10) || 1;
          const configuredScroll = parseInt(widgetSettings.testimonial_slides_to_scroll, 10)
            || parseInt(slickData.sliderSlidesToScroll, 10)
            || 1;
          const scrollFor = (show) => Math.min(configuredScroll, show);

          const prevSel = slickData.prevArrow;
          const nextSel = slickData.nextArrow;
          const $prev = prevSel ? $(prevSel) : $('<div/>');
          const $next = nextSel ? $(nextSel) : $('<div/>');

          if ($el.hasClass('slick-initialized')) {
            $el.slick('unslick');
          }
          $el.removeAttr('data-slick');

          $el.slick({
            rtl: slickData.rtl || false,
            infinite: slickData.infinite !== false,
            speed: slickData.speed || 700,
            arrows: !!($prev.length && $next.length),
            dots: slickData.dots !== false,
            autoplay: slickData.autoplay || false,
            autoplaySpeed: slickData.autoplaySpeed || 1000,
            pauseOnHover: true,
            slidesToShow,
            slidesToScroll: scrollFor(slidesToShow),
            prevArrow: $prev.length ? $prev : false,
            nextArrow: $next.length ? $next : false,
            adaptiveHeight: true,
            responsive: [
              {
                breakpoint: 1025,
                settings: {
                  slidesToShow: slidesToShowTablet,
                  slidesToScroll: scrollFor(slidesToShowTablet),
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: slidesToShowMobile,
                  slidesToScroll: scrollFor(slidesToShowMobile),
                },
              },
            ],
          });
        });
      } catch(e) { console.log('Slick init error:', e); }

      // Init WPR advanced sliders
      try {
        $('.wpr-advanced-carousel:not(.slick-initialized)').each(function() {
          const $el = $(this);
          const slickData = $el.data('slick') || {};
          $el.slick(slickData);
        });
      } catch(e) {}

      // Init ElementsKit Swiper sliders (testimonials, client logos, etc.)
      try {
        if (window.Swiper) {
          document.querySelectorAll('.elementskit-testimonial-slider:not(.ekit-swiper-inited), .elementskit-clients-slider:not(.ekit-swiper-inited)').forEach(function(sliderEl) {
            var config = {};
            try { config = JSON.parse(sliderEl.getAttribute('data-config') || '{}'); } catch(e) {}
            var swiperEl = sliderEl.querySelector('.swiper');
            if (!swiperEl) return;

            var swiperOpts = {
              slidesPerView: config.slidesPerView || 1,
              slidesPerGroup: config.slidesPerGroup || 1,
              spaceBetween: config.spaceBetween || 0,
              loop: config.loop !== false,
              speed: config.speed || 1000,
              autoplay: config.autoplay ? { delay: config.autoplaySpeed || 5000, disableOnInteraction: false } : false,
              breakpoints: config.breakpoints || {}
            };

            if (config.dots) {
              var pagEl = swiperEl.querySelector('.swiper-pagination');
              if (pagEl) swiperOpts.pagination = { el: pagEl, type: 'bullets', clickable: true };
            }
            if (config.arrows) {
              var prevBtn = swiperEl.querySelector('.swiper-button-prev');
              var nextBtn = swiperEl.querySelector('.swiper-button-next');
              if (prevBtn && nextBtn) swiperOpts.navigation = { prevEl: prevBtn, nextEl: nextBtn };
            }

            var sw = new window.Swiper(swiperEl, swiperOpts);
            sliderEl.classList.add('ekit-swiper-inited');

            if (config.autoplay && config.pauseOnHover) {
              $(swiperEl).hover(function() { sw.autoplay.stop(); }, function() { sw.autoplay.start(); });
            }
          });
        }
      } catch(e) { console.log('ElementsKit Swiper init error:', e); }

      // Init Swiper carousels (Elementor image-carousel widgets)
      try {
        if (window.Swiper) {
          document.querySelectorAll('.elementor-image-carousel-wrapper.swiper:not(.swiper-initialized)').forEach(function(swiperEl) {
            const widget = swiperEl.closest('.elementor-widget');
            let settings = {};
            if (widget && widget.dataset.settings) {
              try { settings = JSON.parse(widget.dataset.settings); } catch(e) {}
            }
            const slidesPerView = parseInt(settings.slides_to_show) || 1;
            const slidesPerViewTablet = parseInt(settings.slides_to_show_tablet) || Math.min(slidesPerView, 2);
            const slidesPerViewMobile = parseInt(settings.slides_to_show_mobile) || 1;
            const slidesToScroll = parseInt(settings.slides_to_scroll) || 1;
            const autoplay = settings.autoplay === 'yes';
            const autoplaySpeed = parseInt(settings.autoplay_speed) || 5000;
            const pauseOnHover = settings.pause_on_hover === 'yes';
            const loop = settings.infinite === 'yes';
            const speed = parseInt(settings.speed) || 500;
            const spacing = settings.image_spacing_custom ? parseInt(settings.image_spacing_custom.size) || 0 : 0;
            const hasNav = settings.navigation === 'both' || settings.navigation === 'arrows';
            const hasPag = settings.navigation === 'both' || settings.navigation === 'dots';

            new window.Swiper(swiperEl, {
              slidesPerView: slidesPerView,
              slidesPerGroup: slidesToScroll,
              spaceBetween: spacing,
              autoplay: autoplay ? { delay: autoplaySpeed, disableOnInteraction: settings.pause_on_interaction === 'yes', pauseOnMouseEnter: pauseOnHover } : false,
              loop: loop,
              speed: speed,
              pagination: hasPag ? { el: swiperEl.querySelector('.swiper-pagination'), clickable: true } : false,
              navigation: hasNav ? {
                nextEl: swiperEl.querySelector('.elementor-swiper-button-next'),
                prevEl: swiperEl.querySelector('.elementor-swiper-button-prev')
              } : false,
              breakpoints: {
                0: { slidesPerView: slidesPerViewMobile },
                768: { slidesPerView: slidesPerViewTablet },
                1025: { slidesPerView: slidesPerView }
              }
            });
          });
        }
      } catch(e) { console.log('Swiper init error:', e); }

      // Init WPR FAQ accordion
      try {
        $('.wpr-acc-button').off('click.wpr').on('click.wpr', function() {
          const $panel = $(this).next('.wpr-acc-panel');
          const $parent = $(this).closest('.wpr-advanced-accordion');
          if ($panel.is(':visible')) {
            $panel.slideUp(300);
            $(this).removeClass('wpr-acc-active');
          } else {
            $parent.find('.wpr-acc-panel:visible').slideUp(300);
            $parent.find('.wpr-acc-button').removeClass('wpr-acc-active');
            $panel.slideDown(300);
            $(this).addClass('wpr-acc-active');
          }
        });
      } catch(e) {}

      // Mark already-initialized WPR widgets so elementorFrontend.init() skips them
      try {
        document.querySelectorAll('.wpr-testimonial-carousel.slick-initialized').forEach(el => {
          const widget = el.closest('.elementor-widget');
          if (widget) widget.removeAttribute('data-widget_type');
        });
        document.querySelectorAll('.wpr-advanced-carousel.slick-initialized').forEach(el => {
          const widget = el.closest('.elementor-widget');
          if (widget) widget.removeAttribute('data-widget_type');
        });
      } catch(e) {}

      // Prevent MetForm JS from processing static form replacements
      try {
        document.querySelectorAll('[data-widget_type="metform.default"]').forEach(el => {
          el.removeAttribute('data-widget_type');
        });
      } catch(e) {}

      // Counter animations using jquery-numerator
      try {
        document.querySelectorAll('.elementor-counter-number:not(.counted)').forEach(el => {
          const $el = $(el);
          const toValue = parseFloat($el.data('to-value')) || 0;
          const delimiter = $el.data('delimiter') || ',';
          const rounding = parseInt($el.data('rounding')) || 0;
          const duration = parseInt($el.data('duration')) || 2000;

          $el.addClass('counted');
          if ($.fn.numerator) {
            $el.numerator({
              toValue: toValue,
              delimiter: delimiter,
              rounding: rounding,
              duration: duration
            });
          } else {
            $el.text(toValue.toLocaleString());
          }
        });
      } catch(e) {}

      // Lightbox for Elementor image galleries
      try {
        initLightbox();
      } catch(e) {}

      // React SPA: Elementor scroll animations often never fire; reveal hidden widgets
      try {
        document.querySelectorAll('.elementor-invisible').forEach((el) => {
          el.classList.remove('elementor-invisible');
          const settingsRaw = el.getAttribute('data-settings');
          if (!settingsRaw) return;
          try {
            const animation = JSON.parse(settingsRaw)._animation;
            if (animation) {
              el.classList.add('animated', animation);
            }
          } catch (e) {}
        });
      } catch (e) {}

    }, 800);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
}

export default ElementorInit
